import { createIcon } from '~/modules/ui/primitives/icon/create-icon';

const ChevronsDownUpIcon = createIcon('ChevronsDownUpIcon', [
  ['path', { d: 'M15.25 6.5L12 10L8.75 6.5', key: 'tf8ft8' }],
  ['path', { d: 'M8.75 17.5L12 14L15.25 17.5', key: '1bnj1m' }],
]);

// biome-ignore lint/style/noDefaultExport: ok
export default ChevronsDownUpIcon;
